import { getFirstFocusable } from './helpers.mjs';
/**
 * This helper tool is created to surround the focus locked container with focusable elemnets.
 * By doing so it ensures that the user does not accidentally navigate out of the frame if otherwise
 * there would be no other focusable elements.
 */
export const CATCHER_ATTRIBUTE_NAME = 'skapa-focus-region-boundary';
let elementTemplate;
function getCatcherElement() {
    if (!elementTemplate) {
        elementTemplate = document.createElement('div');
        elementTemplate.tabIndex = 0;
        elementTemplate.toggleAttribute(CATCHER_ATTRIBUTE_NAME, true);
        elementTemplate.style.position = 'fixed';
        elementTemplate.style.top = '0';
        elementTemplate.style.left = '0';
        elementTemplate.style.width = '1px';
    }
    return elementTemplate.cloneNode(true);
}
const catchers = new Map();
// Since we are immediately refocusing, the event should be cancelled to prevent event listener race condition related pitfalls.
function cancelEventAndRefocus(ev, target) {
    ev.preventDefault();
    ev.stopImmediatePropagation();
    target.focus();
}
export function createCatchers(host) {
    const container = host.container;
    if (container.isConnected && container.parentNode) {
        if (catchers.has(host))
            removeCatchers(host);
        const elementBefore = getCatcherElement();
        const elementAfter = getCatcherElement();
        const focusedBefore = function (ev) {
            // Refocus the last element of the container.
            const target = getFirstFocusable([container, ...Array.from(container.querySelectorAll('*'))], true, container);
            if (target)
                cancelEventAndRefocus(ev, target);
        };
        const focusedAfter = function (ev) {
            // Refocus the first element of the container.
            const target = getFirstFocusable([container, ...Array.from(container.querySelectorAll('*'))], false, container);
            if (target)
                cancelEventAndRefocus(ev, target);
        };
        elementBefore.addEventListener('focusin', focusedBefore, { capture: true });
        elementAfter.addEventListener('focusin', focusedAfter, { capture: true });
        container.before(elementBefore);
        container.after(elementAfter);
        catchers.set(host, {
            nodes: [elementBefore, elementAfter],
            listeners: [focusedBefore, focusedAfter],
        });
    }
}
export function removeCatchers(host) {
    const containerBoundFocusCatchers = catchers.get(host);
    if (containerBoundFocusCatchers) {
        containerBoundFocusCatchers.nodes.forEach((catcher, i) => {
            catcher.removeEventListener('focusin', containerBoundFocusCatchers.listeners[i], { capture: true });
            if (catcher && catcher.isConnected)
                catcher.remove();
        });
        catchers.delete(host);
    }
}
